import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePlanReviewFeedbackMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Plan_Review_Feedback_Set_Input>;
}>;


export type UpdatePlanReviewFeedbackMutation = { __typename?: 'mutation_root', update_plan_review_feedback_by_pk?: { __typename?: 'plan_review_feedback', id: any, job_id: any, finding_id: any, user_id: string, decision: string, error_attribution?: string | null, comment?: string | null, created_at: any, updated_at: any } | null };


export const UpdatePlanReviewFeedbackDocument = gql`
    mutation updatePlanReviewFeedback($id: uuid!, $_set: plan_review_feedback_set_input = {}) {
  update_plan_review_feedback_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    job_id
    finding_id
    user_id
    decision
    error_attribution
    comment
    created_at
    updated_at
  }
}
    `;
export type UpdatePlanReviewFeedbackMutationFn = Apollo.MutationFunction<UpdatePlanReviewFeedbackMutation, UpdatePlanReviewFeedbackMutationVariables>;

/**
 * __useUpdatePlanReviewFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdatePlanReviewFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlanReviewFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlanReviewFeedbackMutation, { data, loading, error }] = useUpdatePlanReviewFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdatePlanReviewFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlanReviewFeedbackMutation, UpdatePlanReviewFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlanReviewFeedbackMutation, UpdatePlanReviewFeedbackMutationVariables>(UpdatePlanReviewFeedbackDocument, options);
      }
export type UpdatePlanReviewFeedbackMutationHookResult = ReturnType<typeof useUpdatePlanReviewFeedbackMutation>;
export type UpdatePlanReviewFeedbackMutationResult = Apollo.MutationResult<UpdatePlanReviewFeedbackMutation>;
export type UpdatePlanReviewFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdatePlanReviewFeedbackMutation, UpdatePlanReviewFeedbackMutationVariables>;